module.exports = __webpack_public_path__ + "img/vocus-logo.61e09492.svg";